(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/game-analyzes.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/game-analyzes.js'); 'use strict';

var renderGameAnalyzes = function renderGameAnalyzes() {
  if (svs.core.detect.feature('ft-spelanalyser')) {
    svs.core.module.loadModuleComponent('game-analyzes', function () {
      var gameAnalyzesApp = new svs.tipset.components.gameAnalyzes.GameAnalyzesApplication();
      gameAnalyzesApp.start({
        draw: svs.tipset.collections.draws.getCurrentDraw().toJSON(),
        draws: svs.tipset.collections.draws.toJSON()
      });
    });
  }
};

setGlobal('svs.tipset.gameAnalyzes.renderGameAnalyzes', renderGameAnalyzes);
 })(window);